import React, { useState } from "react";
import { Highlight, connectRefinementList } from "react-instantsearch-dom";
import { orderBy, sortBy } from "lodash";
import styled from "styled-components";
import Select from 'react-select'

const RefinementList = ({
  items,
  isFromSearch,
  refine,
  searchForItems,
  createURL,
  type,
  currentRefinement
}) => {

  const customStyles = {
    indicatorSeparator: () => ({
      display: 'none;'
    })
  }

  //console.log('stocurrentRefinement', currentRefinement);
  //console.log('stoitems', items);

  const toggle = item => {

    //console.log('stoitem', item);

    if (item.label === 'Any') {
      refine('');
    }  else {
      refine(item.label);
    }
  };

  let combinedItems = items.filter(i => {
    return (i.label === 'None') ? false : true;
  });

  combinedItems.sort(function (a, b) {
    return b.value - a.value;
  });
  combinedItems.unshift({label: 'Any', value: 'Any', isRefined: false, count: 0});



  //console.log('combinedItems', combinedItems);

  return (
    <div>
    <Select styles={customStyles} menuPlacement="top" options={combinedItems} onChange={selectedOption =>
      toggle(selectedOption)
    }/>
    </div>
  );
};
const SingleSelectOptionRefinement = connectRefinementList(RefinementList);
export default SingleSelectOptionRefinement;
